import { IntRange } from '../int-range/int-range';
import { Question } from './question.model';
import { ScaleQuestionLabel } from './scale-question-label.model';
import { ScaleQuestionRangeFeedback } from './scale-question-range-feedback.model';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class SliderQuestion extends Question {
  public scaleRange!: IntRange;

  public scaleQuestionLabels!: ScaleQuestionLabel[];

  public scaleQuestionRangeFeedback!: ScaleQuestionRangeFeedback[];

  public scoreWeight!: number;

  public step!: number;

  public static fromDto(dto: any): SliderQuestion {
    const question: SliderQuestion = new SliderQuestion();
    Question.mapBaseProperties(question, dto);
    question.scaleRange = IntRange.fromDto(dto.scaleRange);
    question.scaleQuestionLabels =
      dto.scaleQuestionLabels?.map((labelDto: any) =>
        ScaleQuestionLabel.fromDto(labelDto),
      ) ?? [];
    question.scaleQuestionRangeFeedback =
      dto.scaleQuestionRangeFeedback?.map((feedbackDto: any) =>
        ScaleQuestionRangeFeedback.fromDto(feedbackDto),
      ) ?? [];
    question.scoreWeight = dto.scoreWeight;
    question.step = dto.step;
    return question;
  }
}
